import { MENTION_DASHBOARD_CHANNEL, MENTION_STATUS } from '../../../../../types/dashboard.types';
import useDashboardMentions from '../../../../../hooks/useDashboardMentions';
import { MentionsColumn } from '../Tab1Mentions/MentionsColumn/MentionsColumn';

import './Tab3CustomerChatMentions.scss';

/**
 * Componente que representa el tercer tab del dashboard, correspondiente a la sección de menciones del chat de clientes
 */
const Tab3CustomerChatMentions = () => {
  const { filteredMentions, isColumnsLoading, obtainMentions } = useDashboardMentions({
    isCustomerChat: true
  });

  return (
    <div className="tab3CustomerChatMentions">
      <h2 className="mentionsTitle">Te han mencionado</h2>

      <div className="mentionsColumnsContainer">
        <MentionsColumn
          status={MENTION_STATUS.PENDING_VIEWING}
          groupedMentions={filteredMentions.pendingViewingMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
          mentionChannel={MENTION_DASHBOARD_CHANNEL.CUSTOMER_CHAT}
        />

        <MentionsColumn
          status={MENTION_STATUS.PENDING_RESOLUTION}
          groupedMentions={filteredMentions.pendingResolutionMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
          mentionChannel={MENTION_DASHBOARD_CHANNEL.CUSTOMER_CHAT}
        />

        <MentionsColumn
          status={MENTION_STATUS.CLOSED}
          groupedMentions={filteredMentions.resolvedMentions}
          isLoading={isColumnsLoading}
          onReloadData={() => obtainMentions(true)}
          mentionChannel={MENTION_DASHBOARD_CHANNEL.CUSTOMER_CHAT}
        />
      </div>
    </div>
  );
};

export default Tab3CustomerChatMentions;
